import BaseTableV2 from "~/components/common/base-table-v2/BaseTableV2";
import styles from "./EstimateTab.module.scss";
import classNames from "classnames/bind";
import { MenuVerticalIcon, PlusIcon, SearchIcon } from "~/assets/icons";
import PrimaryButton from "~/components/common/primary-button/PrimaryButton";
import { useEffect, useState } from "react";
import { adminRouteAbsolute } from "~/utils/constants/route";
import { useNavigate, useParams } from "react-router-dom";
import BaseSelectCustom from "~/components/common/base-select-custom/BaseSelectCustom";
import { useAppDispatch, useAppSelector } from "~/redux/hooks";
import { handleDeleteEstimate, handleGetAllEstimate } from "~/thunks/job/jobThunk";
import { EstimateStatusEnum, EstimateStatusOption } from "../../../add-job/constants/add-estimate.constants";
import ModalAlertDelete from "~/components/common/modal-alert-delete/ModalAlertDelete";
import { useTranslation } from "react-i18next";
import { jobActions } from "~/thunks/job/jobSlice";
import jobApi from "~/apis/job";
import { EstimateDetailFormData, EstimateFormData } from "./edit/EstimateDetailFormData";
import { notify } from "~/utils/helper";
import dayjs from "dayjs";
import useDebounce from "~/hooks/useDebounce";

const cx = classNames.bind(styles);

const headCells = [
  { id: "id", label: "Estimate ID", width: "10%" },
  { id: "name", label: "Estimate Name", width: "15%" },
  { id: "date", label: "Estimate Date", width: "20%" },
  { id: "note", label: "Internal Note", width: "15%" },
  { id: "signature", label: "Signature", width: "10%" },
  { id: "total", label: "Total", width: "10%" },
  { id: "status", label: "Status", width: "10%" },
  { id: "actions", label: "Actions", width: "10%" },
];




const EstimateTab = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation(['admin/job', 'admin/common']);

  const [currentFilter, setCurrentFilter] = useState<string | number | null>('all');
  const [openMenuId, setOpenMenuId] = useState<string | null>(null);

  const [estimates, setEstimates] = useState<any[]>([]);
  const [isOpendModalDelete, setOpendModalDelete] = useState(false);
  const [textSreach, setTextSreach] = useState("");
  const debouncedSearch = useDebounce(textSreach, 400);

  const dispatch = useAppDispatch();
  const { jobEstimatesCurrentPage, jobEstimatesTotalPage, jobEstimatesTotalItems, jobEstimates, jobEstimatesFilter } = useAppSelector((state) => state.job);

  const getAllEstimate = () => {
    dispatch(handleGetAllEstimate({
      filter: { ...jobEstimatesFilter, jobId: id }
    }))
      .unwrap()
      .then((response: any) => {
        setEstimates(response.data.responses)
      })
  }

  function formatDate(date: Date) {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  }

  function formatTime(date: Date) {
    const hh = String(date.getHours()).padStart(2, "0");
    const mm = String(date.getMinutes()).padStart(2, "0");
    return `${hh}:${mm}`;
  }

  async function updateStatus(id: string, status: string | number) {
    const res = await jobApi.handleGetAllEstimateDetail(id);
    let resData: any = res.data.data;
    let formData = EstimateFormData(resData);
    let estimate: any = EstimateDetailFormData(formData).data;
    delete estimate.jobId;
    delete estimate.primaryImage;
    delete estimate.estimateLayoutId;
    estimate.status = status;

    await jobApi.updateEstimate(id, estimate);
    getAllEstimate();
  }

  const getEstimateTotal = (estimate: any) => {
    const total = Number(estimate?.totalQuoteSum ?? estimate?.totalAmount ?? 0);
    return Number.isFinite(total) ? total : 0;
  }
  const formatMoney = (value: number) =>
    new Intl.NumberFormat('en-US').format(value);


  useEffect(() => {
    getAllEstimate();
  }, [jobEstimatesFilter])

  useEffect(() => {
    const nextSearch = debouncedSearch.trim();
    if ((jobEstimatesFilter.textSearch ?? "") === nextSearch) return;
    dispatch(jobActions.setEstimateFilter({
      ...jobEstimatesFilter,
      textSearch: nextSearch,
      page: 1,
    }));
  }, [debouncedSearch])


  return (
    <div className={cx("estimate-tab-container")}>

      <div className={'flex items-center justify-between mb-[25px] px-[14px]'}>
        <div className="flex items-center gap-[12px]">
          <div className={cx("search-input-box")}>
            <SearchIcon className={cx("search-icon")} />
            <input
              type="text"
              placeholder="Search"
              className={cx("search-input")}
              value={textSreach}
              onChange={(e) => {
                setTextSreach(e.target.value)
              }}
            />
          </div>
          <div>
            <BaseSelectCustom
              selectedView={currentFilter}
              onViewChange={(viewId) => {
                setCurrentFilter(viewId);
              }}
              viewOptions={[
                { id: "all", label: "All Estimates" },
                { id: "DRAFT", label: "Estimates Draft" },
                { id: "APPROVED", label: "Estimates Approved" },
                { id: "SENT", label: "Estimates Sent" },
                { id: "DENIED", label: "Estimates Denied" },
                { id: "INVOICED", label: "Estimates Invoiced" },
                { id: "VOID", label: "Estimates Void" },

              ]}
              placeholder="---"
              className={cx('select-filter')}
              minWidth={'100px'}
              textAlign="left"
              IconDrop={
                <div className={cx('drop')}>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.4726 5.47357C12.4106 5.41108 12.3369 5.36148 12.2556 5.32764C12.1744 5.29379 12.0872 5.27637 11.9992 5.27637C11.9112 5.27637 11.8241 5.29379 11.7428 5.32764C11.6616 5.36148 11.5879 5.41108 11.5259 5.47357L8.47256 8.52689C8.41058 8.58938 8.33685 8.63897 8.25561 8.67282C8.17437 8.70667 8.08723 8.72409 7.99923 8.72409C7.91122 8.72409 7.82408 8.70667 7.74284 8.67282C7.6616 8.63897 7.58787 8.58938 7.52589 8.52689L4.47256 5.47357C4.41058 5.41108 4.33685 5.36148 4.25561 5.32764C4.17437 5.29379 4.08723 5.27637 3.99923 5.27637C3.91122 5.27637 3.82408 5.29379 3.74284 5.32764C3.6616 5.36148 3.58787 5.41108 3.52589 5.47357C3.40173 5.59847 3.33203 5.76744 3.33203 5.94356C3.33203 6.11969 3.40173 6.28866 3.52589 6.41356L6.58589 9.47356C6.96089 9.84809 7.46922 10.0585 7.99923 10.0585C8.52923 10.0585 9.03756 9.84809 9.41256 9.47356L12.4726 6.41356C12.5967 6.28866 12.6664 6.11969 12.6664 5.94356C12.6664 5.76744 12.5967 5.59847 12.4726 5.47357Z" fill="#789EB4" />
                  </svg>

                </div>
              }
            />
            {/* <BaseSelect
              name='type'
              title={''}
              placeholder='Select type'
              value={currentFilter}
              options={[{ value: "all", label: "All Estimates" }]}
              onChange={()=>{}}
            /> */}
          </div>
        </div>
        <div>
          <PrimaryButton
            title="Create Estimate"
            icon={<PlusIcon className={cx("create-icon")} fill="#ffffff" />}
            iconPosition="left"
            onClick={() => {
              if (id)
                navigate(adminRouteAbsolute.job.estimateCreate(id));
            }}
            className={cx("create-button")}
          /></div>
      </div>

      <div>
        <div className={cx('table-content')}>
          <BaseTableV2
            data={jobEstimates.filter((item: any) => {
              if (currentFilter != "all" && item.status != currentFilter) return false;
              return true;
            })}
            headCells={headCells}
            page={jobEstimatesCurrentPage}
            totalPages={jobEstimatesTotalPage}
            totalItems={jobEstimatesTotalItems}

            onChangePage={(page) => {

              dispatch(jobActions.setEstimateFilter({
                ...jobEstimatesFilter,
                page: page
              }))
            }}
            renderCell={(cellData: any, index: number) => (
              <>
                <td className={cx("table-body-cell", "w-[10%]")}>
                  <p className={cx("text-content", "text-[#F9FBFE] font-[400] font-[14px] leading-[21px]")}>{cellData.id}</p>
                </td>
                <td className={cx("table-body-cell", "w-[15%]")}>
                  <p className={cx("text-content", "text-[#949699] font-[400] font-[14px] leading-[21px]")}>{cellData.name}</p>
                </td>
                <td className={cx("table-body-cell", "w-[13%]")}>
                  <p className={cx("text-content", "text-[#F9FBFE] font-[400] font-[14px] leading-[21px]")}>{dayjs(cellData.estimateDate).format('YYYY-MM-DD')}</p>
                  <p className={cx("text-content", "text-[#949699] font-[400] font-[12px] leading-[18px]")}>{dayjs(cellData.estimateDate).format('HH:mm')}</p>
                </td>
                <td className={cx("table-body-cell", "w-[22%]")}>
                  <p className={cx("text-content", "text-[#949699] font-[400] font-[14px] leading-[21px]")}>{cellData.internalNotes}</p>
                </td>
                <td className={cx("table-body-cell", "w-[10%]")}>
                  <BaseSelectCustom
                    selectedView={cellData.signature}
                    onViewChange={(viewId) => { }}
                    viewOptions={[{ id: "PENDING", label: "Not Requested" }, { id: "SIGNED", label: "Fully Signed" }]}
                    placeholder="---"
                    isViewMode={true}
                    className={cx({
                      'select-signature': true,
                      'signed': cellData.signature == 'SIGNED',
                    })}
                    textAlign="left"
                    IconDrop={
                      <div className={cx('drop')}>
                        <svg width="9" height="6" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M4.243 5.656L0 1.414L1.415 0L4.243 2.828L7.071 0L8.486 1.414L4.243 5.656Z" fill="white" />
                        </svg>

                      </div>
                    }
                  />
                </td>
                <td className={cx("table-body-cell", "w-[10%]")}>
                  <p className={cx("text-content", "text-[#F9FBFE] font-[400] font-[14px] leading-[21px]")}>${formatMoney(getEstimateTotal(cellData))}</p>
                </td>
                <td className={cx("table-body-cell", "w-[10%]")}>
                  <BaseSelectCustom
                    selectedView={cellData.status}
                    onViewChange={(viewId) => {
                      if (
                        viewId === EstimateStatusEnum.DRAFT &&
                        cellData.status !== EstimateStatusEnum.DRAFT
                      ) {
                        return;
                      }
                      updateStatus(cellData.id, viewId ? viewId : "")
                    }}
                    viewOptions={EstimateStatusOption.map((option) => ({
                      ...option,
                      disabled:
                        option.id === EstimateStatusEnum.DRAFT &&
                        cellData.status !== EstimateStatusEnum.DRAFT,
                    }))}
                    placeholder="---"
                    textAlign="left"
                    //  isViewMode={true}
                    className={cx({
                      'select-signature': true,
                      // 'pending': cellData.status == EstimateStatusEnum.DRAFT,
                      'signed': cellData.status == EstimateStatusEnum.SENT,
                      'denied': cellData.status == EstimateStatusEnum.DENIED,
                      'invoiced': cellData.status == EstimateStatusEnum.INVOICED,
                      'void': cellData.status == EstimateStatusEnum.VOID,
                    })}
                    IconDrop={
                      <div className={cx('drop')}>
                        <svg width="9" height="6" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M4.243 5.656L0 1.414L1.415 0L4.243 2.828L7.071 0L8.486 1.414L4.243 5.656Z" fill="white" />
                        </svg>

                      </div>
                    }
                  />
                </td>
                <td className={cx("table-body-cell", "w-[10%] relative")}>
                  <button className={cx("action-button")} onClick={() => setOpenMenuId(cellData.id)}>
                    <MenuVerticalIcon className={cx("action-icon")} />
                  </button>
                  {openMenuId === cellData.id && (
                    <div className="absolute right-[10px] top-[90%] z-50 bg-[#0C192D] border border-[#1f2937] rounded-lg shadow-lg min-w-[120px] overflow-hidden">
                      <button
                        onClick={() => {
                          if (id)
                            navigate(adminRouteAbsolute.job.estimateDetail(id, cellData.id));
                        }}
                        className="w-full text-center px-4 py-2 hover:bg-[#1f2937] transition-colors text-white flex items-center  justify-center gap-2"
                      >

                        <span>View</span>
                      </button>
                      <button
                        onClick={() => {
                          if (id)
                            navigate(adminRouteAbsolute.job.estimateEdit(id, cellData.id));
                        }}
                        // disabled={order.status !== "Draft"}
                        className={`w-full text-center px-4 py-2 hover:bg-[#1f2937] transition-colors text-white flex items-center  justify-center gap-2`}
                      >
                        {/* <EditIcon className="w-4 h-4" /> */}
                        <span>Edit</span>
                      </button>
                      <button
                        onClick={() => {
                          setOpendModalDelete(true);
                        }}
                        // disabled={order.status !== "Draft"}
                        className={`w-full text-center px-4 py-2 hover:bg-[#1f2937] transition-colors text-white flex items-center justify-center gap-2`}
                      >
                        {/* <EditIcon className="w-4 h-4" /> */}
                        <p className="text-center">Delete</p>
                      </button>
                    </div>
                  )}
                </td>
              </>
            )}
          />
        </div>
      </div>
      {/* <h2>Estimate tab</h2> */}

      <ModalAlertDelete
        open={isOpendModalDelete}
        description={"Do you want to delete this?"}
        onCancel={() => {
          setOpenMenuId(null);
          setOpendModalDelete(false);
        }}
        onConfirm={() => {
          try {
            dispatch(handleDeleteEstimate({ id: openMenuId })).unwrap()
              .then((response: any) => {
                getAllEstimate();
                setOpendModalDelete(false);
                notify("success", "Estimate deleted successfully!");
              })
          } catch (error: any) {
            const errorMessage = error?.message || "Failed to delete estimate!";
            notify("error", errorMessage);
          }

        }}
      />

      {/* <EstimateSelectLayout
          open={true}
          onCancel={()=>{
            setOpenMenuId(null);
            setOpendModalDelete(false);
          }}
        /> */}
    </div>
  );
};

export default EstimateTab;
